define(
    'LNRS/Components/Charts/bar',["jquery", "d3", "scrollMagic", "mustache", "LNRS/Components/Charts/Base"],
    function ($, d3, ScrollMagic, mustache, Base) {
        "use strict";

        function BarChart(scope, chartInfo, id) {
            Base.call(this, scope, chartInfo, id);
        }

        BarChart.prototype = Object.create(Base.prototype);


        BarChart.prototype.initChart = function initChart(gDiv, dataset) {

            var svgWidth = $(gDiv).width(),
                svgHeight = 350;

            if ( svgWidth < 830 ) {
                svgHeight = 350;
            } else {
                svgHeight = 450;
            }
            
            $(gDiv).addClass('scrollable');
        
            if (dataset.charttype == 2) {
                $(gDiv).addClass('scrollable long');
            }
            //d3.ns.prefix.myns = "http://www.w3.org/2000/svg";
            var svg = d3.select(gDiv)
                .append('svg')
                .attr('width', svgWidth)
                .attr('height', svgHeight )
                .style('position','relative');

        }
        
        BarChart.prototype.animateChart = function animateChart(gDiv, dataset) {

            dataset.points.forEach(function(d) {
                for (var key in d){
                    d[key] = +d[key];
                }
            })

            var svg = d3.select(gDiv + " svg");
            //svg.style('position','relative');
            // get width and height
            var svgWidth = parseInt(svg.attr('width'));
            var svgHeight = parseInt(svg.attr('height'));

            $(gDiv).append('<div class="scrol-prev" style="left: 80px;"></div>');
            $(gDiv).append('<div class="scrol-next"></div>');
                    
            // init svg
            var margin = { top: 20, right: 30, bottom: 40, left: 50 },
                chartWidth  = svgWidth  - margin.left - margin.right,
                chartHeight = svgHeight - margin.top  - margin.bottom;    
    
            var chartWrapper = svg.append('g')
                .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
        
            var div = d3.select(gDiv).append("div").attr("class", "tooltip-c");

    
            // width and position calculations
            var barsInGroup = Object.keys(dataset.points[0]).length;
            var maxBarsInGroup = barsInGroup;

            dataset.points.forEach(function(d, i) {
                if (barsInGroup >= d.length) {
                    barsInGroup = d.length;
                } else if (dataset.charttype === "3") {
                    maxBarsInGroup = d.length;
                }
            });
            
            var barGroups = Object.keys(dataset.points).length;
    
            var barWidth = 20;
            var spacingBars = 6;
            var inset = 30;
            var spacingGroups = 40;
            var numXTickLines = 1;
            var yAxisWidth = 20,
                clipInset,
                clipWidth,
                realChartWidth;

            if (dataset.charttype == 2) {
                $(gDiv).addClass('long');
                if ( $(window).width() > 992  && $(gDiv).width() < 830 ) {
                    realChartWidth = $(gDiv).width()*1.5 - margin.left - margin.right -2 * inset;
                } else {
                    realChartWidth = 1220 - margin.left - margin.right -2 * inset;
                }   
            } else {
                if ( $(window).width() > 992  && $(gDiv).width() < 830 ) {
                    realChartWidth = $(gDiv).width() - margin.left - margin.right -2 * inset;
                } else {
                    realChartWidth = 830 - margin.left - margin.right -2 * inset;
                }   
            }
            
            if (barGroups > 4) spacingGroups = 20;

            var cInset = (realChartWidth - (spacingGroups * (barGroups - 1) ) ) / (barGroups * 2);
            realChartWidth = realChartWidth - cInset * 2 ;
            
            var x = d3.scaleLinear()
                    .range([0, realChartWidth])
                    .domain([0, (barGroups - 1)]),
                y = d3.scaleLinear()
                    .range([chartHeight, 0])
                    .domain([dataset.yMinValue, dataset.yMaxValue]);
            
            // draw axes
            var axes = chartWrapper.append('g');
        
            var yAxis = d3.axisLeft(y)
            .tickFormat(d3.format(dataset.yTickFormat));;
            //.ticks(dataset.yTickLabels.length)
            if (dataset.gridLines ==1) {
                yAxis.tickSizeInner(-chartWidth+20);
            }
        
            axes.append('g')
                .attr('class', 'y axis')
                .attr('font-size', "14")
                .attr('font-family', "'Source Sans Pro'")
                .attr('transform', 'translate(30,0)')
                .call(yAxis)
                .attr('font-family', "'Source Sans Pro'")
                .selectAll(".tick line")
                .attr("stroke", "#ccc");
                
            // animate grid lines    
            d3.selectAll(gDiv + ' .y.axis line')
                .attr('stroke-dasharray',chartWidth + ' ' + chartWidth )
                .attr('stroke-dashoffset', chartWidth)
                .transition()
                .duration(1000)
                .attr("stroke-dashoffset", 0);
        
            d3.selectAll(".y.axis .tick text")
                .attr('font-size', "14");
            
            // add y axis title
            axes.append("text")
                .text(dataset.yTitle)
                .attr('y',-20)
                .attr('x', -(chartHeight / 2))
                .attr('font-size', 10)
                .attr("style","text-transform:uppercase")
                .attr("transform", "rotate(-90)");
                
            var tickDistance = x(1) - x(0);
        
            switch(dataset.charttype) {
                case "1":            // single bar 
                    spacingBars = 0;
                    if ( barGroups > 4 ) {
                        if ( svgWidth <= 480 ) {
                            spacingGroups = 3;
                        } else {
                            spacingGroups = 10;
                        }
                    } else {
                        if ( svgWidth <= 480 ) {
                            spacingGroups = 10;
                        } else {
                            spacingGroups = 20;
                        }
                    }
                    barWidth = tickDistance - spacingGroups;
                    clipInset = barWidth/2;
                    // find max number of lines for ticks
                    // and increase height of svg as needed
                    for (j = 0; j < dataset.xTickLabels.length; j++) {
                        if ( dataset.xTickLabels[j].length > numXTickLines) {
                            numXTickLines = dataset.xTickLabels[j].length;
                        }
                    }
                    if (numXTickLines > 1 ) {
                        //increase svg height
                        svgHeight += (numXTickLines-1) * 20;
                        svg.attr('height', svgHeight );
        
                        // move title
                        //xTT.attr('y', svgHeight - 20)
                        //$(gDiv).css('padding-bottom','74%');
                    };
                    break;
                case "2":    // single bar, scrolling
                    if ( svgWidth <= 480 ) {
                        spacingBars = 10;
                        spacingGroups = 10;
                        inset = 15;
                    } else {
                        spacingBars = 20;
                        spacingGroups = 20;
                        inset = 30;
                    }
        
                    barWidth = tickDistance - spacingGroups;
                    //realChartWidth = chartWidth - inset*2 ;
                    
                    clipInset = barWidth/2;
                    //clipWidth = realChartWidth + barWidth;
            
                    break;
                default:
        
                    if ( barsInGroup > 4 ){
                        if ( svgWidth <= 480 ) {
                            spacingBars = 2;
                            spacingGroups = 6;
                            clipInset = 15;
                        } else {
                            spacingBars = 3;
                            spacingGroups = 15;
                            clipInset = 30;
                        }
                    } else {
                        if ( svgWidth <= 480 ) {
                            spacingBars = 1;
                            spacingGroups = 6;
                            clipInset = 15;
                        } else {
                            spacingBars = 6;
                            spacingGroups = 30;
                            clipInset = 30;
                        }
                    }
                    var gw = tickDistance - spacingGroups;
                    barWidth = (tickDistance - spacingGroups - spacingBars * (barsInGroup - 1))/barsInGroup;
                    //inset = inset + (barWidth*barsInGroup + (spacingBars *(barsInGroup -1))) /2;
                    //realChartWidth = chatWidth - gw;
                    //inset = (barWidth*barsInGroup + (spacingBars *(barsInGroup -1)))/2;
                    /*
                    * check if there are enough colors for all lines
                    */
                    if (dataset.colors.length && dataset.points.length) {
                        while (dataset.colors.length < maxBarsInGroup) {
                            dataset.colors = dataset.colors.concat(dataset.colors);
                        }
                    }
            } 
        
            // clip rectangle - visible area
            var clipWrap = chartWrapper.append('clipPath')
            .attr('id','clipChart')
            .append('rect')
                .attr('x',0)
                .attr('y',0)
                .attr('width', svgWidth - margin.left - margin.right - 2*inset)
                .attr('height',chartHeight + 60);
                    
            var innerBox = chartWrapper.append('g')
                .attr('class', 'inner-wrapper')              
                .attr("transform","translate("+( margin.left )+",0)")
                .append("g")
                .attr("class","scrollingChart")
                .style('transition','all .4s ease');
        
            // draw bars
            var numberOfSkippedBars = 0;
            
            dataset.points[0].forEach(function(item, i) {
                if (!+item) {
                    numberOfSkippedBars++;
                }
            });
/*
            if(dataset.charttype == 2) {
                //var xtPos = x((barGroups-1)/3)  + cInset;
                var xtPos = $(gDiv).width()/2;
            } else {        
                //var xtPos = x((barGroups-1)/2) + inset*2 + cInset;
                var xtPos = $(gDiv).width()/2;
            }
*/
            var xtPos = (svgWidth - margin.left - margin.right - 2*inset)/2 + 50;
                
            // X axis title
            var xTT = axes.append("text")
                .text(dataset.xTitle)
                .attr('y', svgHeight - 20)
                .attr('x', xtPos)
                .attr('text-anchor','middle')
                .attr("style","text-transform:uppercase")
                .attr('font-size', 10);
            
            var ttx, j;
            var groupWidth = tickDistance - spacingGroups;
            var bars = innerBox.selectAll(".bar");
        
            dataset.points.forEach(function(d,i){
                if ( dataset.charttype === "3" ) {
                    if (numberOfSkippedBars > 0 ) {
                        ttx = (barWidth/2)*numberOfSkippedBars + (spacingBars/2)*(numberOfSkippedBars);
                    } else {
                        ttx = 0;
                    }
                } else {
                    ttx= 0;
                }
                        
                ttx = ttx + x(i) - spacingBars;
                //manually add x ticks
                innerBox.append("text")
                    .text(dataset.xTickLabels[i][0])
                    .attr('text-anchor', 'middle')
                    .attr('y', chartHeight + 20)
                    .attr('x', x(i) + groupWidth/2)
                    .attr('font-size', 14);
                if ( dataset.xTickLabels[i].length > 1 ) {
                    for (j = 1; j < dataset.xTickLabels[i].length; j++) {
                        innerBox.append("text")
                            .text(dataset.xTickLabels[i][j])
                            .attr('text-anchor', 'middle')
                            .attr('y', chartHeight + 18*(j+1))
                            .attr('x', x(i) + groupWidth/2)
                            .attr('font-size', 14);
                    }
                }
            
                for(j=0; j < maxBarsInGroup; j++) {
                    switch(dataset.charttype){
                        case "1":
                            ttx += spacingBars;
                            var tty = chartHeight - y(d[j]);
                            break;
                        case "2":
                                //ttx = inset + x(i) + barWidth*j - barWidth*barsInGroup/2;
                                ttx += spacingBars;
                            var tty = chartHeight - y(d[j]);
                            break;
                        case "3":
                            if (!+d[j]) {
                                continue;
                            }
        
                            ttx += spacingBars;
                            var tty = chartHeight - y(d[j]);
                            
                            break;
                        default:
                            ttx += spacingBars;
                            var tty = chartHeight - y(d[j]);
                    }
        
                    var ttt = d[j];
        
                    innerBox.append("rect")
                        .attr("x", ttx )
                        .attr("y", chartHeight)
                        .attr("width", barWidth)
                        .attr("class", "bar" + j)
                        .attr('id','b-'+ i + '-' + j)
                        .attr("fill", dataset.colors[j])
                        //.attr("height", (chartHeight - y(d['line' + j])) )
                        // animate bars
                        .attr("height", 0)
                
                        // attach tooltips
                        .on("mouseleave", function() {
                            $(gDiv + " .tooltip-c")
                                .css("opacity",0)
                                .css("top",0)
                                .css("left",0);
                        })
                        .on("mousemove",function(){
                            var div = d3.select(gDiv + " .tooltip-c");
                            var offset = $(gDiv).offset();
                            var currPos = $(this).attr('id');
                            var currArrPos = currPos.split('-');
                            var currX; 
                            var ttBox = div.node().getBoundingClientRect();
                            var f = d3.format(dataset.tooltipFormat);
                            div.html("<p style='color:"+dataset.colors[currArrPos[2]]+"'>"+f(d[currArrPos[2]]) + "</p>");
        
                            $(gDiv + " .tooltip-c").css("left", (d3.event.pageX - offset.left - ttBox.width/2  )+"px")
                                .css("top", (d3.event.pageY - offset.top - ttBox.height - 20) +"px")
                                .css("opacity", 1);
                        },this)
                        .transition()
                        .duration(200)
                        .delay( i * 50 )
                        .attr("y", chartHeight - tty)
                        .attr("height", tty);
                
                        ttx +=  barWidth;
                    }
            });

    // add prev next shaders
    chartWrapper.append('rect')
    .attr('class','scroll-bg-prev')
    .attr('x',30)
    .attr('y',0)
    .attr('width','50')
    .attr('height',chartHeight)
    .attr('fill','#fff');

    chartWrapper.append('rect')
    .attr('class','scroll-bg-next')
    .attr('x',chartWidth-20)
    .attr('y',0)
    .attr('width','50')
    .attr('height',chartHeight)
    .attr('fill','#fff');


    //scrolling part
    $(document).on('click', gDiv + ' .scrol-next', [], function(){
        var myChart = $(this).parent().find('.scrollingChart');
        var moveWindow = $(this).parent()[0].getBoundingClientRect().width - margin.left - margin.right - 2*inset,
            moveDist = moveWindow * 0.8; 

        var myWidth = myChart[0].getBBox().width;
                //get transform css
        var tmp = myChart.attr('style');
        var currPos = 0;
        if( tmp.includes('transform') ) {
            currPos = parseInt(tmp.split(';')[1].split('(')[1]);
            if( isNaN(currPos) ) {
                currPos = 0;
            } 
        }
        
        if ( Math.abs(currPos) + moveWindow + moveDist > myWidth ) {
            currPos = moveWindow - myWidth - 40 ;
            $(gDiv + ' .scrol-next').hide();
            $(gDiv + ' .scroll-bg-next').css('display','none');
        } else {
            currPos -= moveDist;
        }

        myChart.css('transform','translateX(' + currPos + 'px)');
        $(gDiv + ' .scrol-prev').show();
        $(gDiv + ' .scroll-bg-prev').css('display','block');
    },this);

    $(document).on('click', gDiv + ' .scrol-prev', [], function(){
        var myChart = $(this).parent().find('.scrollingChart');
        var currPos = myChart[0].getBBox().x;
        var myWidth = myChart[0].getBBox().width;

        var moveWindow = $(this).parent()[0].getBoundingClientRect().width - margin.left - margin.right - 2*inset,
            moveDist = moveWindow * 0.8; 

        //get transform css
        var tmp = myChart.attr('style');
        var currPos = 0;
        if( tmp.includes('transform') ) {
            currPos = parseInt(tmp.split(';')[1].split('(')[1]);
            if( isNaN(currPos) ) {
                currPos = 0;
            } 
        }
        
        if (currPos + moveDist > 0) {
            currPos = 0;
            $(gDiv + ' .scrol-prev').hide();
            $(gDiv + ' .scroll-bg-prev').css('display','none');
        } else {
            currPos += moveDist;
        }
        myChart.css('transform','translateX(' + currPos + 'px)');
        $(gDiv + ' .scrol-next').show();
        $(gDiv + ' .scroll-bg-next').css('display','block');
    },this);
     

        }

        return function initBarChart(args) {
            return args.IsExperienceEditorEditing ? null : new BarChart(
                args.scope,
                args.chartInfo,
                args.id);
        };
    });
